import { Box, Chip, Typography } from "@mui/material";
import Utils from "../../utils";

export function ReadOnlySDG({ sdg }: { sdg: Array<number> }) {
  if (!sdg) {
    return <Typography variant="subtitle2">No SDGs assigned</Typography>;
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "start" }}>
      <Typography variant="subtitle2" sx={{ paddingBottom: 0.5 }}>
        SDGs
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "start",
          gap: 0.5,
        }}
      >
        {sdg.map((sdg) => (
          <Chip
            key={sdg}
            sx={{
              backgroundColor: Utils.SDG.getSDGChipColor(sdg),
              color: "white",
              fontWeight: 600,
            }}
            label={`${sdg}. ${Utils.SDG.getSDGDisplayValue(sdg)}`}
          />
        ))}
      </Box>
    </Box>
  );
}
